module.exports = __webpack_public_path__ + "static/ilustracao-organizacao-fiscal-fe0f66ae832066a986152e5a911821f3.svg";